import MutationTypes from '../../MutationTypes';
export default {
    setNetworkState: ({ commit }, payload) => {
        commit(MutationTypes.SET_NETWORK_STATE, payload);
    },
    setScreenOrientation: ({ commit }, payload) => {
        commit(MutationTypes.SET_SCREEN_ORIENTATION, payload);
    }
};
